import React from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Control, Field, Label } from 'components/UIComponents/Form';
import ValidationError from 'components/FormControls/ValidationError';

export default ({
  name,
  control,
  errors,
  dropzoneProps: { getRootProps, getInputProps },
}) => {
  const { t } = useTranslation();

  return (
    <Field>
      <Control>
        <Label required htmlFor={name}>
          {t('datagate.external.blackBox.fileUpload.form.file.label')}
        </Label>
        <Controller
          name={name}
          control={control}
          render={({ onChange }) => (
            <div {...getRootProps({ className: 'dropzone' })}>
              <input
                id={name}
                {...getInputProps({
                  onChange: e => onChange(e.target.files[0]),
                })}
              />
              <p>
                {t('datagate.external.submission.fileUpload.message.uploadBox')}
              </p>
            </div>
          )}
          rules={{
            required: t('datagate.external.fileUpload.form.file.required'),
          }}
        />
      </Control>
      <ValidationError name={name} errors={errors} />
    </Field>
  );
};
